<template>
  <div class="UserGuide flex-al-start flex-jc-ard">
    <sp-card class="cus-card flex-42">
      <div class="cate">
        <p v-triangle class="cate-header">{{ $l('UserGuide') }}</p>
        <p class="cate-title mg-b-20">{{ $l('Catalog') }}</p>
        <el-collapse v-model="activeName">
          <el-collapse-item v-for="category in categorys" :key="category.id" :name="category.id">
            <template #title>
              <div class="text-left" style="width: 94%; background-color: rgba(0,0,0,0);position:relative;z-index: 9"
                   :class="activeName == category.id && !activeChild ? 'sp-color-1' : ''"
                   @click.stop="collapseClick(category)">
                {{ category.title }}
              </div>
            </template>
            <table class="max-box tab">
              <tr v-for="(cate,index) in category.subs" :key="index" class="tab-row">
                <td class="flex-al-center flex-jc-bt tab-row-content">
                  <span class="pd-l-20 pointer tab-row-content-head" :class="(activeName == category.id && activeChild == cate.id) ?'sp-color-1':''" @click="showContent(cate)">{{ cate.title }}</span>
                </td>
              </tr>
            </table>
          </el-collapse-item>
        </el-collapse>
        <SpPagenation v-model:curr-page="currPage" class="text-center" :page-size="pageSize" :total="total"
                      @change-currpage="(val) => currentChange(val)" />
      </div>
    </sp-card>
    <!--    <div :style="{width:'80px'}" /> -->
    <div class="desc flex-55 text-left">
      <p v-triangle class="desc-header">{{ $l('Process') }}</p>
      <div class="desc-content" v-html="nowCategory.content" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import spCard from '@/components/common/SpCard'
import SpDatePicker from './SpDatePicker.vue'
import { closeGlobalLoading, showGlobalLoading } from '@/components/common/SpLoading'
import jsonBig from 'json-bigint'
import { getGuidanceAllApi } from '../../request/APIs/common'
import _groupBy from 'lodash/groupBy'
import _difference from 'lodash/difference'
import SpPagenation from './SpPagenation'

export default {
  name: 'UserGuide',

  nameSpace: 'UserGuide',

  components: {
    SpPagenation,
    spCard,
    SpDatePicker
  },

  props: {
  },

  data () {
    return {
      imgUrl: require('@/assets/crg.png'),
      allList: {},
      categorys: [],
      nowCategory: {},
      showChild: false,
      activeName: null,
      activeChild: null,

      currPage: 1,
      total: 0,
      pageSize: 10
    }
  },

  created () {
    this.getNoticesCatalog(this.currPage)
  },

  methods: {
    showContent (info) {
      this.nowCategory = info
      this.activeName = info.parentId
      this.activeChild = info.id
    },

    getNoticesCatalog (currPage) {
      getGuidanceAllApi(currPage).then(res => {
        const data = res.data
        const ids = Object.keys(data)
        const arr = []
        ids.forEach(key => arr.push(data[key]))
        this.allList = arr
        this.total = this.allList.length
        if (this.allList) {
          this.currentChange()
        }
      })
    },

    collapseClick (info) {
      this.activeName = info.id
      this.activeChild = null
      this.nowCategory = info
    },

    currentChange () {
      const begin = (this.currPage - 1) * this.pageSize
      const end = this.currPage * this.pageSize
      this.categorys = this.allList.slice(
          begin,
          end
      )
      this.activeName = this.categorys[0].id
      this.nowCategory = this.categorys[0]
    }
  }
}
</script>

<style scoped lang="less">
.UserGuide{
  ///deep/ .SpCard {
  //  overflow: visible !important;
  //  .card-content{
  //    overflow: visible !important;
  //  }
  //}
  /deep/ .el-collapse-item__content{
    padding-bottom: 0 !important;
  }
  /deep/ .el-collapse-item__header{
    font-size: 16px;
  }
  padding-top: @gap;
  .cate{
    // padding: 0 @gap 0 @gap;
    text-align: left;
    >.cate-header{
      margin:0;
      font-size: 18px;
      padding: @gap 0 @gap 0;
    }
    >.cate-title{
      margin:0 0 20px 0;
      font-size: 18px;
      font-weight: 800;
    }
    .tab{
      // .maxBox();
      border-collapse:collapse;
      margin-top: 0;
      margin-bottom: 0;
      >.tab-row{
        height:40px;
        line-height: 40px;
        //border-bottom: 1px solid #E5E5E5;
        //border-top: 1px solid #E5E5E5;
        >.tab-row-content{
          font-size: 16px;
          font-weight: 400;
          >.tab-row-content-tail{
            opacity: 0.7;
          }
        }
      }
    }
  }
  >.desc{
    /*width: 40%;*/
    /*flex-grow: 1;*/
    max-width: 1046px;
    overflow-y: auto;
    background-color: #FFFFFF;
    padding:@gap;
    >.desc-header{
      text-align: left;
      font-size: 18px;
      font-weight: normal;
    }
    >.desc-content{
      word-break: break-word;
      width: 95%;
      background-color: #F6F6F6;
      margin: 0 auto;
      padding:@gap;
      >.title{
        font-size: 18px;
        font-weight: bold;
      }
      >.step{
        text-align: left;
        padding-left: @gap;
      }
      >.step-desc{
        text-align: left;
        padding-left: @gap;
        >*{
          display: inline-block;
          vertical-align: text-top;
        }
      }
    }
  }
}
</style>
